export default "__VITE_ASSET__BMLAaM6z__"